import React, { useEffect, useState } from 'react'
import { Grid } from '@material-ui/core'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { useMediaQuery } from 'react-responsive'
import GridItem from '../GridItem'
import ButtonBase from '../ButtonBase'
import { laptop, mediaQueriesBreakpoints } from '../../../styles/mixins'
import { breakOffersToLines } from './SmartGridUtils'

/**
* Smart Grid presents items in a smart way according to the layout or object we received.
 * the array size control the design biew on the page*
* below are examples of input and output:
*
 * input		   |	  	output		  														   |
 __________________|_______________________________________________________________________________|
 array length: 2   |	   					[ [ 1, 2 ] ]       									   |
 __________________|_______________________________________________________________________________|
 array length: 10  |	   [ [ 1, 2, 3 ], [ 4, 5, 6 ], [ 7, 8, 9, 10 ] ]       					   |
 __________________|_______________________________________________________________________________|
 array length: 7   |	   [ [ 1, 2, 3 ], [ 4, 5, 6, 7 ] ]      			   					   |
 __________________|_______________________________________________________________________________|
 array length: 8   |	   [ [ 1, 2, 3, 4 ], [ 5, 6, 7, 8 ] ]       		   					   |
 __________________|_______________________________________________________________________________|
 array length: 9   |	   [ [ 1, 2, 3 ], [ 4, 5, 6 ], [ 7, 8, 9 ] ]      	  					   |
 __________________|_______________________________________________________________________________|
 array length: 13   |	   [ [ 1, 2, 3 ], [ 4, 5, 6 ], [ 7, 8, 9 ], [ 10, 11, 12, 13 ] ]      	   |
 __________________|_______________________________________________________________________________|
 array length: 1   |	   [ [ 1 ] ]      	   													   |
 __________________|_______________________________________________________________________________|
 array length: 0   |	   [ [ ] ]      	   													   |
 __________________|_______________________________________________________________________________|
**
 * each inner array is one new row on the grid
 * when you see 3 items in array they have big size design
 * when you see 4 items in array they have small size design
 * */

const ActionButton = styled.div`
	padding: 0 20px;
	margin-block-start: 4px;
	width: 100%;

	@media ${laptop} {
		display: flex;
		justify-content: center;
		align-items: center;
		margin-block-start: 14px;
	}

	button {
		width: 100%;

		@media ${laptop} {
			width: 426px;
		}
	}
`

const SLICE_LIMIT = 7
const SLICE_LIMIT_INNER_ARR = 2

interface SmartGridProps {
	list: any[]
	onBannerAndOfferClick: (item: any) => void
}

const SmartGrid = ({ list, onBannerAndOfferClick }: SmartGridProps) => {
	const [showAllDeals, setShowAllDeals] = useState(false)
	const [isLoaded, setIsLoaded] = useState(false)
	const isDesktop = useMediaQuery({ query: mediaQueriesBreakpoints.laptop })
	const arr = breakOffersToLines(list)
	const sliceLimit = showAllDeals ? list.length : SLICE_LIMIT
	const sliceInnerArrLimit = showAllDeals ? arr.length : SLICE_LIMIT_INNER_ARR
	const dealsButtonText = showAllDeals ? 'Hide Deals' : 'More Deals'

	useEffect(() => setIsLoaded(true), [])

	return (
		<Grid container spacing={!isDesktop ? 3 : 4} justifyContent="center">
			{!isDesktop && isLoaded
				? list?.slice(0, sliceLimit).map((item, key) => (
						<Grid item xs={12} sm={6} key={item.id + key}>
							<GridItem data={item} onClick={() => onBannerAndOfferClick(item)} />
						</Grid>
				  ))
				: arr?.slice(0, sliceInnerArrLimit).map((item, key) =>
						item.map((innerItem, key2) => (
							<Grid item xs={12} sm={6} md={item.length < 4 ? 4 : 3} key={innerItem.id + key + key2}>
								<GridItem data={innerItem} onClick={() => onBannerAndOfferClick(innerItem)} $isBig={item.length < 4} />
							</Grid>
						))
				  )}

			{!isLoaded &&
				list?.slice(0, sliceLimit).map((item, key) => (
					<Grid item xs={12} sm={6} key={item.id + key}>
						<GridItem data={item} onClick={() => onBannerAndOfferClick(item)} />
					</Grid>
				))}

			{isLoaded && ((!isDesktop && list?.length > SLICE_LIMIT) || (isDesktop && arr?.length > SLICE_LIMIT_INNER_ARR)) && (
				<ActionButton>
					<ButtonBase $type="secondary" onClick={() => setShowAllDeals(!showAllDeals)}>
						{dealsButtonText}
					</ButtonBase>
				</ActionButton>
			)}
		</Grid>
	)
}

export default SmartGrid

SmartGrid.propTypes = {
	list: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
	onBannerAndOfferClick: PropTypes.func,
}
